import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { KpiGrid, StatusChip } from "@/components/kcc/Kpi";
import { Panel, ModuleHeader } from "@/components/kcc/Panel";
import { DataTable, statusToChip } from "@/components/kcc/DataTable";
import { AIAdvisor } from "@/components/kcc/AIAdvisor";
import { BookOpen, Search } from "lucide-react";

export default function Knowledge360() {
    const [data, setData] = useState(null);
    const [q, setQ] = useState("");
    useEffect(() => { api.get("/knowledge/docs").then(({ data }) => setData(data)); }, []);
    const rows = (data?.documents || []).filter((d) => {
        if (!q) return true;
        const s = q.toLowerCase();
        return d.title.toLowerCase().includes(s) || d.doc_no.toLowerCase().includes(s) || d.department.toLowerCase().includes(s);
    });
    return (
        <div className="space-y-6">
            <ModuleHeader
                kicker="Knowledge360"
                title="Enterprise Knowledge Repository"
                description="SOPs, engineering standards, technical manuals, lessons learned and Board papers — semantically searchable and used by the KCC360 AI advisor via RAG."
            />
            <KpiGrid kpis={data?.kpis || []} accent="purple" cols={4} />
            <div className="grid grid-cols-1 xl:grid-cols-3 gap-6">
                <div className="xl:col-span-2">
                    <Panel
                        title="Controlled Documents"
                        subtitle={`${rows.length} of ${(data?.documents || []).length} shown`}
                        accent="purple"
                        actions={
                            <div className="flex items-center gap-2 bg-white/[0.03] border border-white/10 rounded-md px-2.5 py-1 w-72">
                                <Search className="w-3.5 h-3.5 kcc-text-silver" />
                                <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search knowledge…" className="bg-transparent outline-none text-xs flex-1" data-testid="knowledge-search" />
                            </div>
                        }
                    >
                        <DataTable
                            columns={[
                                { key: "doc_no", label: "Doc #" },
                                { key: "title", label: "Title" },
                                { key: "type", label: "Type" },
                                { key: "department", label: "Owner" },
                                { key: "revision", label: "Rev" },
                                { key: "classification", label: "Class", render: (r) => <StatusChip status={r.classification === "Confidential" ? "warning" : r.classification === "Restricted" ? "critical" : "info"}>{r.classification}</StatusChip> },
                                { key: "status", label: "Status", render: (r) => <StatusChip status={statusToChip(r.status)}>{r.status}</StatusChip> },
                            ]}
                            rows={rows.slice(0, 30)}
                            testid="knowledge-table"
                        />
                    </Panel>
                </div>
                <Panel title="Knowledge AI" subtitle="Ask questions grounded in the KCC knowledge base" accent="purple" className="min-h-[560px] flex flex-col">
                    <div className="flex-1 -m-5">
                        <AIAdvisor module="knowledge" embedded />
                    </div>
                </Panel>
            </div>
        </div>
    );
}
